import React, { useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
// Material Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Slide
} from '@material-ui/core';
//assets
import CloseIcon from '../../assets/close.svg';
// Styles
import './styles.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const PopUpModal = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(!ref ? true : false);

  useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    }
  }));

  const handleClose = () => {
    setOpen(false);
    props.onRefresh ? props.onRefresh() : {};
  };

  var fullWidthBool = props.width ? true : false;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth={fullWidthBool}
      fullScreen={props.fullScreen}
      classes={{
        paperFullWidth: props.width,
        paper: props.position
      }}
      className={props.className}
    >
      <DialogTitle className="dialog-header">
        {props.header}
        <IconButton
          edge="start"
          color="inherit"
          data-testid="close-button"
          onClick={handleClose}
          aria-label="close"
        >
          <img src={CloseIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent>{props.body}</DialogContent>
    </Dialog>
  );
});

PopUpModal.displayName = 'PopUpModal';

PopUpModal.propTypes = {
  header: PropTypes.element,
  body: PropTypes.element,
  width: PropTypes.string,
  position: PropTypes.string,
  className: PropTypes.string,
  fullScreen: PropTypes.bool,
  onRefresh: PropTypes.func
};
export default PopUpModal;
